// JavaScript Document
//components/signs/option/Table.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
	maxHeight:'calc(100vh - 84px)',
	//maxHeight: '100%'
  },
});


export default function OptionTable(props) {
	const classes = useStyles();
	const {items, onSelect} = props;
	
	const handleSelect = (row) => {
		if(onSelect){
			onSelect(row);
		}
	}
	

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="ITS Sign Settings">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
	  		<TableCell>Description</TableCell>
            <TableCell>Type</TableCell>
	  		<TableCell>Default</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow hover role="checkbox" key={row.id} onClick={(e) => {handleSelect(row)}}>
				<TableCell>{row.name}</TableCell>
	  			<TableCell>{row.input_description ? row.input_description : row.description}</TableCell>
	  			<TableCell>{row.data_type}</TableCell>
				<TableCell>{row.default_value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
